import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { apiService } from '../main';
import Nyelvek from '../data/enums/nyelvek';
import store from '../store';
import { AppStoreTypes } from '../store/modules/app';
import { TisztaTiszaFunctions } from '../functions/TisztaTiszaFunctions';

Vue.use(VueI18n);
var language = TisztaTiszaFunctions.GetLocale();

export const i18n = new VueI18n({
  locale: language,
  fallbackLocale: Nyelvek.Angol,
  messages: {},
});

export const Geti18nTranslations = async function() {
  var result = await apiService.GetAllTranslations();
  let dictionary = result.dictionary;
  for (const key in dictionary) {
    i18n.setLocaleMessage(key, dictionary[key]);
  }
  await store.dispatch(AppStoreTypes.languages.set, {
    value: result.languages,
  });
};
